<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rMlYfV/tc-custom/9781480477636.jpg?1700426046313" alt="This image is the cover for the book Last Sunrise, The Post-War Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Sunrise, The Post-War Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The real history of World War II’s most daring fighter squadron is the inspiration for this riveting novel of adventure and romance in the Far East</b><br/> Three years after the liberation of Singapore, transport pilot Lee Crane is finally ready to leave. The Berlin airlift is on, and there’s decent money to be made if you possess both your own plane and a practiced disregard for safety. One last drink with his Indo-Air fly buddies at the Long Bar in Raffles hotel and Crane is gone. Then he sees her: the tall, beautiful redhead he had every reason to believe was dead. If Elsa is alive—and still angry, judging by the sock to the jaw she greets him with—what else might Crane have gotten wrong about the past?<br/> In 1941, Lee Crane was a Flying Tiger, one of dozens of American pilots recruited to join the Chinese Air Force in the fight against the Japanese. Wild in the air and on the ground, the Tigers broke hearts all over Burma, and Crane was no different—until he fell in love with a stunning Anglo-Indian widow. But in the chaos of war, Crane lost track of the woman of his dreams, and spent the next seven years convincing himself it wasn’t meant to be. Now a chance encounter with another long-lost beauty has him ready to plunge back into the past, praying he will come up with a different answer this time.<br/> The Last Sunrise <i>is the 2nd book in the Post-War Trilogy, which also includes </i>After Midnight<i> and </i>Dying Day.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Ryan
      </h2>
      
      <p class="authorDescription body article">Robert Ryan was born in Liverpool and has worked as a race car mechanic, journalist, jazz composer, university lecturer, and more. He has written many novels, including&#160;<i>Early One Morning</i>, a <i>Sunday Times</i> (UK) bestseller. He lives in North London with his wife, three children, a dog, and a deaf cat.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25585e9c